export default __webpack_public_path__ + "static/r-favicon-7b4f59279200de7787817cc446a48187.ico";